import React, {Component, Fragment} from 'react';
import { connect }          from 'react-redux';
import Validate             from 'app/validation/validation';

import './index.scss';
import newsletter_mobile  from 'assets/images/newsletter-mobile.jpg';
import newsletter_desktop from 'assets/images/newsletter-desktop.jpg';
import x_close from 'assets/icons/x-close-white-icon.svg';

//components
import AnimatedInput from 'components/forms/animated_input';
import {sendAppLinkSms, resetBenefitStatus} from "../../../../redux/actions";
import {getMediaPath} from "../../../../app/functions";

class BenefitLinkPopup extends Component {

    constructor(props) {
        super(props);
        this.state = {
            animation_class: '',
            first_try:true,
            form:{
                phone:{
                    val:'',
                    valid:false,
                    rules:['not_empty','cell'],
                    errMsg:''
                }
            },
        };
        this.animateOut  = this.animateOut.bind(this);
        this.animateIn   = this.animateIn.bind(this);
        this.handleInput = this.handleInput.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    /* add class for animation after it is inserted into the DOM */
    componentDidMount() {
        this.animateIn();
    }
    animateIn() {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.setState({animation_class: 'active'});
            })
        })
    }
    /* first remove the active class for exit animation then call the callback */
    animateOut(callback) {
        this.props.resetBenefitStatus();
        this.setState({animation_class: ''});
        setTimeout(() => {
            if(callback) {
                callback(this.state.selected_id);
            }
            this.props.handleClose();
        }, 200);
    }

    handleInput(val, name) {
        let validate = Validate(val, this.state.form[name].rules);
        let is_valid = validate.valid;
        let msg = validate.msg;
        let new_state = {...this.state.form,[name]: {...this.state.form[name], val:val, valid:is_valid, errMsg:msg}};
        this.setState({form:new_state});
    }
    handleSubmit(e) {
        e.preventDefault();
        let form_valid = true;
        let new_state = this.state.form;

        for(let field in this.state.form) {
            let validate = Validate(this.state.form[field].val, this.state.form[field].rules);
            let is_valid = validate.valid;
            let msg = validate.msg;

            new_state[field].valid = is_valid;
            new_state[field].errMsg = msg;

            if(is_valid === false) {
                form_valid = false;
            }
        }
        this.setState({form:new_state, first_try:false});

        if(form_valid) {
            this.props.sendAppLinkSms({phone: this.state.form.phone.val, benefitId:this.props.benefitId},'benefit');
        }
    }

    render() {
        const appStatus = this.props.benefitStatusDown;
        const device = this.props.deviceState;
        const Text   = this.props.text.benefit;
        const showErrorMsg = !this.state.first_try && !this.state.form.phone.valid;

        return (
            <div className = { "backdrop " + this.state.animation_class } onClick = { () => this.animateOut() }>
                <div className = {"popup_wrapper benefit-link " + this.state.animation_class} onClick = { (e) => e.stopPropagation() }>
                    <div className = "popup_content">
                        <div className="top-right">
                            <button className = "x_close_icon"
                                    onClick = { () => this.animateOut() }
                                    aria-label="סגור">
                                <img src={ getMediaPath(x_close) } alt="" />
                            </button>
                            <img className="image" src={ (device === 'mobile' ? getMediaPath(newsletter_mobile) : getMediaPath(newsletter_desktop)) } alt="" />
                        </div>
                        <div className="bottom-left">
                            {!appStatus &&
                            <Fragment>
                                <div className="title">{Text.title}</div>
                                <div className="subtitle">{Text.content}</div>
                                <form onSubmit={this.handleSubmit}>
                                    <AnimatedInput type="text"
                                                   name="phone"
                                                   className="phone-input"
                                                   placeholder={Text.web_app_download_popup_placeholder}
                                                   value={this.state.form.phone.val}
                                                   onChange={this.handleInput}
                                                   showError={showErrorMsg}
                                                   errorMessage={this.state.form.phone.errMsg}/>
                                    <button type="submit"
                                            className="green-button submit-button">{Text.btnText}</button>
                                </form>
                            </Fragment>
                            }
                            {appStatus &&
                                <div className="title-div">
                                    {Text.after_content}
                                    <button className="green-button close"
                                            onClick = { () => this.animateOut() }>סגור</button>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

//connect to redux store
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        text: store.config.PopTrans,
        benefitStatusDown: store.data.BenefitDown,
    }
}

const mapDispatchToProps = dispatch =>{
    return{
        sendAppLinkSms: (payload, sender) =>dispatch(sendAppLinkSms(payload, sender)),
        resetBenefitStatus: () =>dispatch(resetBenefitStatus()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(BenefitLinkPopup);